import { useTranslation } from 'react-i18next';

import { Body1 } from '@myphx-engineering/phx-design-system';
import { IllustrationCard, NoResultsIllustration } from '@phx/myphx-lib';

export const NoMatch = () => {
    const { t } = useTranslation();

    return (
        <IllustrationCard
            Illustration={NoResultsIllustration}
            variant="bare"
            illustrationPosition="top"
            withShadow={false}
            illustrationSize="lg"
            header={<Body1 ta="center">{t('cabinet.history.noMatch')}</Body1>}
        />
    );
};
